import { Snack } from '@main/snackbar/const';
import * as SnackbarActions from '../actions';
import { SnackbarState } from '../snackbar-state';

export const initialState: SnackbarState = {
  snackbar: [],
  hidden: false,
};

export function reducer(
  state: SnackbarState = initialState,
  action:
    | SnackbarActions.SetSnack
    | SnackbarActions.AddSnack
    | SnackbarActions.RemoveSnack
    | SnackbarActions.RemoveAll
    | SnackbarActions.HideSnackbar,
): SnackbarState {
  switch (action.type) {
    case SnackbarActions.ADD_SNACK: {
      const snack = action.payload;

      if (!state.snackbar.some((item: Snack) => item.id === snack.id)) {
        return { ...state, snackbar: [...state.snackbar, snack] };
      }

      return state;
    }

    case SnackbarActions.REMOVE_SNACK: {
      return { ...state, snackbar: state.snackbar.filter((snack: Snack) => snack.id !== action.payload) };
    }

    case SnackbarActions.REMOVE_ALL: {
      return { ...state, snackbar: state.snackbar.filter((snack) => !action.payload(snack)) };
    }

    case SnackbarActions.HIDE_SNACKBAR: {
      return { ...state, hidden: true };
    }

    default: {
      return state;
    }
  }
}
